import { Autocomplete } from '@mui/material';
import React, { useState } from 'react';
import i18n from '../../i18n';
import BaseInput from './base-input.component';

/**
 * 自动完成单选输入框
 */
export default function SelectAutocompleteComponent(props: {
    // 输入的值
    inputVal?: string;
    // 标签名
    label?: string;
    // 表单回调
    onChange?: (value: string) => void;
    // 选项
    options: Array<{
        label: string;
        value: string
    }>
    /** 为 true 时隐藏输入框浮动标签（与 `FormFieldCell` 等外置标签配合） */
    hiddenLabel?: boolean;
}) {
    const { inputVal, label, options, hiddenLabel } = props;
    const [curValue, setCurValue] = useState<{ label: string, value: string } | undefined>(
        {
            label: '',
            value: ''
        }
    );

    React.useEffect(() => {
        setCurValue(options.find(item => item.value === inputVal) || { label: '', value: '' })
    }, [inputVal]);

    return (
        <div className=''>
            <Autocomplete
                options={options}
                size='small'
                autoHighlight
                noOptionsText={i18n.t('general_text_no_data')}
                getOptionLabel={(option) => option.label}
                value={curValue}
                onChange={(event, newValue) => {
                    console.log('onChange', newValue)
                    setCurValue(newValue);
                    props.onChange?.(newValue?.value || '')
                }}
                isOptionEqualToValue={(option) => option.value === inputVal}
                disableClearable={true}
                renderInput={(params) => (
                    <BaseInput
                        {...params}
                        fullWidth
                        variant={'outlined'}
                        label={hiddenLabel ? undefined : label}
                        hiddenLabel={Boolean(hiddenLabel)}
                        value={inputVal || ''}
                        required={true}
                        regularType={'required'}
                    />
                )}
            />
        </div>

    )
}